import { Link } from "react-router-dom";
import styled from "styled-components";

export const LandingMenuContainer = styled.div`
  display: flex;
  color: rgb(175, 175, 175);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
`;

export const MenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;

  @media (max-width: 768px) {
    width: 100%;
    align-items: center;
  }
`;

export const MenuItem = styled.div`
  font-size: 25px;
  line-height: 1.6;
  cursor: pointer;
  margin: 5px;

  &:hover {
    color: white;
    transform: scale(0.97);
  }

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
    text-align: center;
    padding: 10px;
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;

  &:hover {
    color: white;
  }

  &:visited {
    color: white;
  }
`;